import R from 'ramda'

/**
 * Remove a folder of `id` from a list of folders
 * @param {number} id - The id of the folder to delete
 * @param {Array} folders - The array of folders from the current state
 */
export default function withoutFolderId(id, folders) {
  const folder = R.find(R.propEq('id', id), folders)

  if (!folder) throw new Error(`Folder with id ${id} not found in folders`)

  return R.without([folder], folders)
}
